import styled from 'styled-components';
import React from 'react';
import { SectionParent, BlueButton } from '../../StyledComponents';
import { navigate } from 'gatsby';
import { Title } from '../HomePage/HomepageSectionOne';
import lottie, { AnimationItem } from 'lottie-web';

const SectionOneTitle = styled(Title)`
  color: #dfe3f0;
  font-size: 48px;
  line-height: 58px;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    text-align: center;
    font-size: 28px;
    line-height: 32px;
  }
`;

const Section = styled(SectionParent)`
  display: grid;
  padding-top: 5rem !important;
  position: relative;
  z-index: 0;
  padding-bottom: 0rem !important;
  display: grid;
  /* padding: 0rem 25rem; */
  /* grid-template-columns: repeat(14, 1fr); */
  background: #03103b;
`;

const SolutionsContent = styled.div`
  grid-column: span 7;
  display: grid;
  /* padding-bottom: 4rem; */
  @media (max-width: 768px) {
    grid-column: span 14;
    padding-bottom: 2rem;
    padding-left: 0;
  }
  @media (max-width: 520px) {
    grid-column: span 14;
    padding-left: 0;
  }
`;
const GreenButtonWrapper = styled.div`
  /* margin-top: -6rem; */
  justify-content: center;
  display: flex;
  margin-top: 5px;
  margin-bottom: 0rem;
  @media (max-width: 768px) {
    justify-self: center;
    margin-top: 0;
  }
`;
const GreenButtonNew = styled(BlueButton)`
  background: #02b875;
`;

const FromManufacturingW = styled.h2`
  font-size: 18px;
  line-height: 32px;
  color: #abbbf0;
  text-align: center;
  width: 50%;
  margin-left: 25%;
  margin-top: -20px;
  @media (max-width: 1700px) {
    font-size: 18px;
  }
  @media (max-width: 1440px) {
    font-size: 18px;
  }
  @media (max-width: 1024px) {
    font-size: 18px;
  }
  @media (max-width: 768px) {
    font-size: 16px;
    width: 80%;
    margin-left: 10%;
    text-align: center;
  }
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 400;
  @media (max-width: 520px) {
    /* margin-bottom: -50%; */
    margin-top: 0.8rem;
    width: 100%;
    padding: 0 3rem;
    line-height: 20px;
    margin-left: 0;
    padding: 15px;
  }
  @media (max-width: 375px) {
    padding: 0 1rem;
  }
`;

const FromManufacturingSM = styled.h2`
  font-size: 18px;
  line-height: 32px;
  color: #abbbf0;
  text-align: center;
  width: 50%;
  margin-left: 25%;
  margin-top: 16px;
  margin-bottom: 20px;
  @media (max-width: 1700px) {
    font-size: 18px;
  }
  @media (max-width: 1440px) {
    font-size: 18px;
  }
  @media (max-width: 1024px) {
    font-size: 16px;
  }
  @media (max-width: 768px) {
    font-size: 14px;
    width: 80%;
    margin-left: 10%;
    text-align: center;
  }
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 400;
  @media (max-width: 520px) {
    /* margin-bottom: -50%; */
    width: 100%;
    padding: 0 3rem;
    line-height: 1.5;
    margin-left: 0;
    font-size: 14px !important;
  }
  @media (max-width: 375px) {
    padding: 0 1rem;
  }
`;

const GreenText = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  color: #66d1b1;
`;

const EsperManagePage = styled.div`
  padding-top: 4rem;
  @media (max-width: 768px) {
    padding-top: 1rem;
  }
`;
const HeroImgContainer = styled.div`
  display: grid;
`;

const AnimationContainerMobile = styled.div`
  width: 65%;
  max-width: 1045px;
  margin: auto;
  @media (max-width: 520px) {
    width: 100%;
  }
  @media (min-width: 1500px) {
    width: 100%;
  }
`;

class DeveloperSectionOne extends React.PureComponent<any, any> {
  animation?: AnimationItem;

  async componentDidMount() {
    const Hero = await import('../../lottieAnimations/Hero.json');
    this.animation = lottie.loadAnimation({
      name: 'developer-hero',
      container: document.getElementById('hero-animation')!,
      loop: true,
      renderer: 'svg',
      autoplay: true,
      animationData: Hero,
    });
  }

  render() {
    return (
      <div style={{ position: 'relative' }}>
        <Section>
          <SolutionsContent>
            <EsperManagePage>
              {/* <EsperManageSubHeading>ESPER MANAGE</EsperManageSubHeading> */}
              <SectionOneTitle
                style={{
                  textAlign: 'center',
                }}
              >
                Full-Stack Tools for Android
                <br />
                Device Deployments
              </SectionOneTitle>
              <FromManufacturingW>
                The world’s most innovative DevOps teams use Esper to create
                responsive connections between device, app, and cloud backend.
              </FromManufacturingW>
              <FromManufacturingSM>
                Esper’s Android DevOps APIs, SDK & CLI support cloud-connected
                product development across a variety of Android form factors.
              </FromManufacturingSM>
              <GreenButtonWrapper>
                <GreenButtonNew onClick={() => navigate('/signup')}>
                  Start Now
                </GreenButtonNew>
              </GreenButtonWrapper>
              <GreenText>Esper is free for fleets up to 100 devices</GreenText>
              <HeroImgContainer>
                <AnimationContainerMobile id="hero-animation" />
              </HeroImgContainer>
            </EsperManagePage>
          </SolutionsContent>
        </Section>
      </div>
    );
  }
}
export default DeveloperSectionOne;
